import styled from 'styled-components'
import { widthResize, widthFull, heightHeader, primaryGradient, boxShadow } from '../Resources/Theme'

const Header = styled.header`
  position: fixed;
  height: ${heightHeader};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  left: ${props => props.resize ? widthResize : widthFull};
  box-shadow: ${boxShadow};
  background: rgba(245, 242, 235, 0.92);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(212, 205, 191, 0.75);
  transition: .5s;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 4;
  
  @media (max-width: 992px) {
    left: 0;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 0 18px;
  }
`

Header.Left = styled.div`
  height: ${heightHeader};
  display: none;
  text-align: center;
  color: #203022;

  @media (max-width: 992px) {
    width: 33%;
    display: flex;
  }
`

Header.Brand = styled.div`
  display: none;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    align-self: center;
    justify-content: center;
    display: flex;
  }
`

Header.Brand.Logo = styled.img`
  @media (max-width: 992px) {
    max-height: 40px;
  }
`

Header.Right = styled.div`
  height: ${heightHeader};
  display: flex;
  justify-content: flex-end;
  max-height: ${heightHeader};

  @media (max-width: 992px) {
    width: 100%;
  }
`

Header.Right.Icon = styled.div`
  height: ${heightHeader};
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
  color: #2c2a20;
  cursor: pointer;
  border-radius: 14px;

  &:hover {
    background-color: rgba(59, 58, 46, 0.06);
  }

  @media (max-width: 992px) {
    width: 40px;
  }
`

Header.Right.Image = styled.img`
  border-radius: ${props => props.maxHeight ? props.maxHeight : '30px'};
  height: ${props => props.maxHeight ? props.maxHeight : '44px'};
  width: ${props => props.maxHeight ? props.maxHeight : '44px'};
  object-fit: cover;
  box-shadow: 0 8px 18px rgba(16, 26, 18, 0.12);
`

export default Header